import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const domainRegex = /^(https?:\/\/)(www\.)?([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

export const domainIsValid = (control: FormControl) =>
    domainRegex.test((control.value || "").toLowerCase()) ? null : { DomainInvalid: messages.validation.domainInvalid };
